var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThreeDots = function SvgThreeDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3c0 1.4-1.1 2.5-2.5 2.5S7.5 4.4 7.5 3 8.6.5 10 .5s2.5 1.1 2.5 2.5zM12.5 10c0 1.4-1.1 2.5-2.5 2.5S7.5 11.4 7.5 10 8.6 7.5 10 7.5s2.5 1.1 2.5 2.5zM10 19.5c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z"
  })));
};
export default SvgThreeDots;